var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize"}],ref:"label",on:{"resize":_vm.resizeListenerDebounced,"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(_vm._s(_vm.truncatedLabel))])
}
var staticRenderFns = []

export { render, staticRenderFns }